const { /* SOME_ENVIRONMENT_VARIABLE,*/ NODE_ENV = '' } = process.env;

const environment = NODE_ENV.toLowerCase();

export { environment };
